export default __webpack_public_path__ + "static/media/confirmnew.21a53567.svg";